// Pure helpers for the console's tester debug-note panel — ported from the
// buyer SPA (frontend/web/src/components/workspace/debug-note-panel.tsx). Copied
// rather than lifted into @recruiter/shared: the shared package must not import
// an app, and these few lines are the whole surface — the heavy porting risk is
// the screenshot lib (lib/debug-screenshot.ts), not this.
//
// The tester's NAME (required — attribution is the whole point) is folded into
// the note text itself, together with an `[admin]` marker so a note filed from
// the console is distinguishable from a buyer-SPA note in the same "Debug notes"
// review tab — one string in the one `note_text` column, no schema/wire change.

// Remembers the tester's name across notes (and reloads) so they only type it
// once. Same `recruiter_admin_app_*` key convention as the rest of this app's
// local state (lib/persisted-state.ts).
export const TESTER_NAME_KEY = "recruiter_admin_app_debug_tester_name";

// Fold the tester's name + the admin marker into the note text as a two-line
// string: `name: <who>` / `note: [admin] <what>`. It lands verbatim in the
// admin Note cell (which preserves the newline). Pure so it's unit-tested.
export function composeAdminDebugNote(name: string, note: string): string {
  return `name: ${name.trim()}\nnote: [admin] ${note.trim()}`;
}

// Read/write the remembered tester name against a Storage — the app passes
// `window.localStorage`; tests pass a fake (the test env is `node`, no DOM).
// Best-effort: storage may be unavailable (private mode), in which case we just
// don't remember.
export function readTesterName(storage: Storage | undefined): string {
  try {
    return storage?.getItem(TESTER_NAME_KEY) ?? "";
  } catch {
    return "";
  }
}

export function writeTesterName(storage: Storage | undefined, value: string): void {
  try {
    storage?.setItem(TESTER_NAME_KEY, value);
  } catch {
    /* best-effort — remembering the name is a convenience, not load-bearing. */
  }
}
